import { render, staticRenderFns } from "./Manifest_draft.vue?vue&type=template&id=37782f72&"
import script from "./Manifest_draft.vue?vue&type=script&lang=js&"
export * from "./Manifest_draft.vue?vue&type=script&lang=js&"
import style0 from "./Manifest_draft.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports